import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { MpsLoaderService } from '../../services/mps-loader.service';

@Component({
  selector: 'mps-loader',
  templateUrl: './mps-loader.component.html',
  styleUrl: './mps-loader.component.scss',
  imports: [AsyncPipe, TranslateModule],
})
export class MpsLoaderComponent {
  loader = inject(MpsLoaderService);
}
